module.exports = __webpack_public_path__ + "static/media/drive.3601194a.png";